// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { GetBackOrdersApiParameter } from "@store/Framework/Services/BackOrderService";
import { BackOrdersState } from "@store/Framework/Store/Store/Data/BackOrders/BackOrdersState";
import { SetDeleteModalIsOpenParameter } from "@store/Framework/Store/Store/Data/BackOrders/Handlers/SetDeleteModalIsOpen";
import { SetPendingQuantityParameter } from "@store/Framework/Store/Store/Data/BackOrders/Handlers/SetPendingQuantity";
import { SetSelectedBackOrderItemParameter } from "@store/Framework/Store/Store/Data/BackOrders/Handlers/SetSelectedBackOrderItem";
import { SetUpdateModalIsOpenParameter } from "@store/Framework/Store/Store/Data/BackOrders/Handlers/SetUpdateModalIsOpen";
import { BackOrderCollectionModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: BackOrdersState = {
    isLoading: {},
    idByBackOrderNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
    deleteModalIsOpen: false,
    updateModalIsOpen: false,
    selectedBackOrderItem: null,
    pendingQuantity: 0,
};

const actions = {
    "Data/BackOrders/BeginLoadBackOrders": (
        draft: Draft<BackOrdersState>,
        action: { parameter: GetBackOrdersApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/BackOrders/CompleteLoadBackOrders": (
        draft: Draft<BackOrdersState>,
        action: { parameter: GetBackOrdersApiParameter; collection: BackOrderCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.backOrders!,
            order => storeProductIdByOriginalOrderNumber(draft, order),
        );
    },
    "Data/BackOrders/Reset": () => {
        return initialState;
    },
    "Data/BackOrders/SetDeleteModalIsOpen": (
        draft: Draft<BackOrdersState>,
        action: { parameter: SetDeleteModalIsOpenParameter },
    ) => {
        draft.deleteModalIsOpen = action.parameter.isOpen;
    },
    "Data/BackOrders/SetUpdateModalIsOpen": (
        draft: Draft<BackOrdersState>,
        action: { parameter: SetUpdateModalIsOpenParameter },
    ) => {
        draft.updateModalIsOpen = action.parameter.isOpen;
    },
    "Data/BackOrders/SetPendingQuantity": (
        draft: Draft<BackOrdersState>,
        action: { parameter: SetPendingQuantityParameter },
    ) => {
        draft.pendingQuantity = action.parameter.pendingQuantity;
    },
    "Data/BackOrders/SetSelectedBackOrderItem": (
        draft: Draft<BackOrdersState>,
        action: { parameter: SetSelectedBackOrderItemParameter },
    ) => {
        draft.selectedBackOrderItem = action.parameter.backOrderItem;
    },
};

function storeProductIdByOriginalOrderNumber(draft: Draft<BackOrdersState>, line: any) {
    const originalOrderNumber = line?.originalOrderNumber ?? "";

    // Require at least originalOrderNumber to store
    if (!originalOrderNumber) {
        return;
    }

    draft.idByBackOrderNumber[originalOrderNumber] = line?.id ?? "";
}

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BackOrdersActions = Parameters<typeof reducer>[1];
export default reducer;
